export function parseSettingsTimestamp(value: string | null | undefined): number | null {
  if (value == null) {
    return null
  }

  const trimmed = value.trim()
  if (!trimmed) {
    return null
  }

  const asNumber = Number(trimmed)
  if (!Number.isNaN(asNumber)) {
    return asNumber < 1e12 ? asNumber * 1000 : asNumber
  }

  const parsed = Date.parse(trimmed)
  return Number.isNaN(parsed) ? null : parsed
}
